import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Footer = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <footer className="footer">
      <div className="footer__container container">
        <img src={Imgs.logo} alt="logo" className="footerimgnone" />
        <div className="footer__context">
          <h3>{translations[selectedLanguages].footer.navigationTitle}</h3>
          <ul>
            <li>
              <NavLink to="/">{translations[selectedLanguages].footer.navigationHome}</NavLink>
            </li>
            <li>
              <NavLink to="/about">{translations[selectedLanguages].footer.navigationAbout}</NavLink>
            </li>
            <li>
              <NavLink to="/services">{translations[selectedLanguages].footer.navigationServices}</NavLink>
            </li>
            <li>
              <NavLink to="/templates/websites">{translations[selectedLanguages].footer.navigationTemplates}</NavLink>
            </li>
            <li>
              <NavLink to="/contact">{translations[selectedLanguages].footer.navigationContact}</NavLink>
            </li>
          </ul>
        </div>
        <div className="footer__context">
          <h3>{translations[selectedLanguages].footer.servicesTitle}</h3>
          <ul>
            <li>{translations[selectedLanguages].footer.servicesFirst}</li>
            <li>{translations[selectedLanguages].footer.servicesSecond}</li>
            <li>{translations[selectedLanguages].footer.servicesThird}</li>
          </ul>
        </div>
        <div className="footer__context footer__cont">
          <h3>{translations[selectedLanguages].footer.Contacts}</h3>
          <ul>
            <li>
              <NavLink to="tel:+37498936909">
                <img src={Imgs.phone} alt="phone" />
                +374 98 93 69 09
              </NavLink>
            </li>
            <li>
              <NavLink to="mailto:websitepro.contacts@gmail.com">
                <img src={Imgs.gmailImg} alt="gmail" />
                websitepro.contacts@gmail.com
              </NavLink>
            </li>
            <li>
              <NavLink target="_blank" to="https://www.instagram.com/websitepro.am/">
                <img src={Imgs.instagram} alt="instagram" className="instafaceimg" />
                WebsitePro.am
              </NavLink>
            </li>
            <li>
              <NavLink target="_blank" to="https://www.facebook.com/share/1A5bBn8pfd/?mibextid=wwXIfr">
                <img src={Imgs.facebooklogo} alt="facebook" className="instafaceimg" /> WebsitePro.am
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
